import { SYSTEM_CODE } from '../CommissionCalculator/system-info'

export const systemsByDefault = [SYSTEM_CODE.direct_common, SYSTEM_CODE.telegramAds]
export const systemsByDefaultNew = [SYSTEM_CODE.direct_common, SYSTEM_CODE.yandex_network]
export const updatedSystemKeys = {
  [SYSTEM_CODE.direct_common]: 'Яндекс Директ',
  [SYSTEM_CODE.yandex_network]: 'РСЯ',
  [SYSTEM_CODE.yanavigator]: 'Яндекс Навигатор',
  [SYSTEM_CODE.yadzen]: 'Яндекс ПромоСтраницы',
  [SYSTEM_CODE.get_radio]: 'GETRADIO',
  [SYSTEM_CODE.yaspravochnik]: 'Яндекс Бизнес'
}

export const systemsByDefaultTurnovers = {
  [SYSTEM_CODE.direct_common]: 550000,
  [SYSTEM_CODE.telegramAds]: 150000
}

export const systemsByDefaultTurnoversNew = {
  [SYSTEM_CODE.direct_common]: 550000,
  [SYSTEM_CODE.yandex_network]: 150000
}

export const order = [
  'direct_common',
  'target_group',
  'telegramAds',
  'ozon',
  'wildberries',
  'avitoAds',
  'yanavigator',
  'google_internal',
  'tiktok_ads',
  'avito',
  'yaspravochnik',
  'calltouch',
  'telega_in',
  'get_radio',
  'wow_blogger',
  'two_gis',
  'oohdesk_dsp',
  'seo_wizard',
  'i_digital',
  'marketolog_pro',
  'vkDzen',
  'sber_ads',
  'vk_adblogger',
  'gnezdo',
  'yadzen',
  'yandex_network',
  'samba'
]
